import { Utils } from "@/plugins/utils"
import axios from "axios"
import { runtimeConfig } from '@/config/runtimeConfig'

export default {
	namespaced: true,
	state: {
		lxl: null,
		insert: false,
		update: false,
		loading: false,
	},
	getters: {
		getInsert: state => {
			return state.insert
		},
		getUpdate(state) {
			return state.update
		},
		getLoading: state => {
			return state.loading
		},
		getLxl(state) {
			let lxl = { ...state.lxl }
			return lxl
		},
		getLxltenta: state => state.lxl.lxltenta ?? "",
		getLxllogin: state => state.lxl.lxllogin ?? "",
	},
	mutations: {
		set(state, lxl) {
			state.lxl = lxl
			if (lxl) state.update = true
		},
		initForm(state) {
			state.insert = false
			state.update = false
			state.lxl = null
		},
		setLxl(state, lxl) {
			state.lxl = lxl
		},
		setLoading: (state, loading) => (state.loading = loading),
		setLastUpdatedRegister(state, lastUpdatedRegister) {
			state.lastUpdatedRegister = lastUpdatedRegister
		},
	},
	actions: {
		setUpdate: ({ commit }, update) => commit("setUpdate", update),
		setInsert: ({ commit }, insert) => commit("setInsert", insert),
		setFormError: ({ commit }, error) => commit("setFormError", error),
		setLoading: ({ commit }, loading) => commit("setLoading", loading),
		async getLxltenta({ dispatch }) {
			const lxl = await dispatch("get")
			return lxl.lxltenta
		},
		async get({ dispatch, commit }, isFromLogin) {
			let payload
			let url = `/Oryx/UserParameters/Find`

			try {
				commit("setLoading", true)
				commit("initForm")

				if (isFromLogin) {
					url += `?isFromLogin=${isFromLogin}`
					await axios
						.get(runtimeConfig.apiUri + url, {
							headers: { "Content-Type": "application/json" },
						})
						.then(response => {
							payload = Utils.ValidateAxiosResponse(response.data)
						})
				}
				await this._vm.$axios.get(url).then(response => {
					payload = Utils.ValidateAxiosResponse(response.data)
				})
			} catch (error) {
				dispatch(
					"parameters/openDialog",
					{
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					},
					{ root: true },
				)
			} finally {
				commit("setLoading", false)
			}

			return payload
		},
		async getUserBlockInfo({ commit, dispatch }, isFromLogin) {
			commit("setLoading", true)
			let payload
			try {
				const response = await axios.get(
					runtimeConfig.apiUri + `/Oryx/UserParameters/GetUserBlockInfo?isFromLogin=${isFromLogin}`,
					{
						headers: { "Content-Type": "application/json" },
					},
				)
				payload = Utils.ValidateAxiosResponse(response.data)
				if (payload == null) {
					return { maximumTries: null, isActivated: false }
				}
				return { maximumTries: payload.lxltenta, isActivated: payload.lxltenat, expirablePass: payload.lxlexppass }
			} catch (error) {
				dispatch(
					"parameters/openDialog",
					{
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					},
					{ root: true },
				)
			} finally {
				commit("setLoading", false)
			}

			return payload
		},
		async getMaximumUserTries({ commit, state }, isFromLogin) {
			commit("setLoading", true)
			try {
				const response = await axios.get(
					runtimeConfig.apiUri + `/Oryx/UserParameters/GetMaximumUserTries?isFromLogin=${isFromLogin}`,
					{
						headers: { "Content-Type": "application/json" },
					},
				)
				const payload = Utils.ValidateAxiosResponse(response.data)
				return payload.lxltenta
			} catch (error) {
				state.form.error = error.message
			} finally {
				commit("setLoading", false)
			}
		},
		async getIsUserBlockActivated({ commit, state }, isFromLogin) {
			commit("setLoading", true)
			try {
				const response = await axios.get(
					runtimeConfig.apiUri + `/Oryx/UserParameters/GetIsUserBlockActivated?isFromLogin=${isFromLogin}`,
					{
						headers: { "Content-Type": "application/json" },
					},
				)
				const payload = Utils.ValidateAxiosResponse(response.data)
				return payload.lxltenat
			} catch (error) {
				state.form.error = error.message
			} finally {
				commit("setLoading", false)
			}
		},

		async find({ dispatch, commit }, isFromLogin) {
			commit("initForm")
			let payload = await dispatch("get", isFromLogin).then(lxl => {
				commit("set", lxl)
				return true
			})
			return payload
		},
		async save({ getters, dispatch }) {
			if (getters.getUpdate) {
				return await dispatch("update")
			}
			return await dispatch("insert")
		},
		async insert({ commit, getters, dispatch }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			let payload = await this._vm.$axios
				.post("/Oryx/UserParameters/Insert", getters.getLxl)
				.then(response => {
					commit("setLastUpdatedRegister", Utils.ValidateAxiosResponse(response.data))
					commit("setLxl", null)
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async update({ commit, getters, dispatch }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			let payload = await this._vm.$axios
				.put("/Oryx/UserParameters/Update", getters.getLxl)
				.then(response => {
					commit("setLastUpdatedRegister", Utils.ValidateAxiosResponse(response.data))
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async delete(store) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Excluindo", indeterminate: true },
				{ root: true },
			)
			await this._vm.$axios
				.delete("/Oryx/UserParameters/Delete")

				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					store.dispatch("find")
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
	},
}
